import clsx from 'clsx';
import { observer } from 'mobx-react';
import Label from '../../../../../../Resource/FormTemplates/Inputs/Label';
import MultipleSelectionsInput from '../../../../../../Resource/FormTemplates/Inputs/MultipleSelectionsInput';
import { MultipleSelectionsField } from '../../../../../../Resource/FormTemplates/Types';
import { T } from '../../../../../../Translations';
import Button from '../../../../../Form/Button';
import LicenseAllocationsStore from '../Store';
import { noop } from '@kofno/piper';

interface Props {
  field: MultipleSelectionsField;
  licenseAllocationsStore: LicenseAllocationsStore;
}

function Form({ field, licenseAllocationsStore }: Props) {
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        licenseAllocationsStore.submitting();
      }}
    >
      <Label field={field} />
      <MultipleSelectionsInput field={field} />
      <p
        className={clsx(
          'my-12 rounded border-1 border-solid border-teal-400 bg-teal-500 px-4 py-3',
          'text-sm text-gray-800',
        )}
      >
        <T kind="Participants will not be notified when licenses are..." />
      </p>
      <Button
        type="submit"
        value="Submit"
        onClick={noop}
        data-intercom-target="license-allocation-submit-button"
        className={clsx(
          'rounded-md border border-solid border-gray-900 bg-white',
          'py-2.5 px-5 text-sm font-semibold text-gray-900',
        )}
      />
    </form>
  );
}

export default observer(Form);
